import { Controller } from "@hotwired/stimulus"

// Handles form submission with loading state
export default class extends Controller {
  static targets = ["submitButton", "spinner", "loadingText", "form"]

  connect() {
    this.isSubmitting = false
    // Store original button text if not already stored
    if (this.hasSubmitButtonTarget && !this.submitButtonTarget.dataset.originalText) {
      this.submitButtonTarget.dataset.originalText = this.submitButtonTarget.textContent.trim()
    }
  }

  submit(event) {
    // Prevent multiple submissions
    if (this.isSubmitting) {
      event.preventDefault()
      event.stopPropagation()
      return false
    }
    
    this.isSubmitting = true
    
    if (this.hasSubmitButtonTarget) {
      // Store original button text if not already stored
      if (!this.submitButtonTarget.dataset.originalText) {
        this.submitButtonTarget.dataset.originalText = this.submitButtonTarget.textContent.trim()
      }
      
      // Store original classes
      if (!this.submitButtonTarget.dataset.originalClasses) {
        this.submitButtonTarget.dataset.originalClasses = this.submitButtonTarget.className
      }
      
      // Update button appearance (but don't disable - let form submit)
      this.submitButtonTarget.classList.add("opacity-75", "cursor-wait")
      
      // Show spinner if available
      if (this.hasSpinnerTarget) {
        this.spinnerTarget.classList.remove("hidden")
      }
      
      // Update button text with spinner
      const originalText = this.submitButtonTarget.dataset.originalText || this.submitButtonTarget.textContent.trim()
      this.submitButtonTarget.innerHTML = `
        <span class="inline-flex items-center">
          ${originalText}
          <svg class="animate-spin -mr-1 ml-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </span>
      `
    }
    
    // Allow form to submit normally - don't prevent default
  }

  reset() {
    if (this.hasSubmitButtonTarget) {
      // Re-enable the submit button
      this.submitButtonTarget.disabled = false
      
      // Restore original classes
      if (this.submitButtonTarget.dataset.originalClasses) {
        this.submitButtonTarget.className = this.submitButtonTarget.dataset.originalClasses
      } else {
        this.submitButtonTarget.classList.remove("opacity-75", "cursor-not-allowed")
      }
      
      // Hide spinner if available
      if (this.hasSpinnerTarget) {
        this.spinnerTarget.classList.add("hidden")
      }
      
      // Restore original text
      if (this.submitButtonTarget.dataset.originalText) {
        this.submitButtonTarget.textContent = this.submitButtonTarget.dataset.originalText
      }
    }
  }
}
